import {useEffect, useState} from 'react';
import {getLocations, insertLocation} from "../../api/Api";
import {Button, Card, InputNumber, Table, Row, Col} from 'antd';
import {toUtcDateString} from "../../util/timeutils";

export const LocationTab = ({session, refresh, onRefresh, onApiFail, props}) => {

    const [locations, setLocations] = useState([]);
    const [longitude, setLongitude] = useState(undefined);
    const [latitude, setLatitude] = useState(undefined);

    useEffect(() => {
        getLocations().then(r => {
            setLocations(r.map(row => {
                return {...row, key: row.userId}
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [onApiFail, refresh]);

    const columns = [
        {
            title: 'User',
            dataIndex: 'firstname',
            key: 'user',
            render: (val, record, index) => {
                return `${record.firstname} ${record.lastname}`;
            }
        },
        {
            title: 'Longitude',
            dataIndex: 'longitude',
            key: 'longitude'
        },
        {
            title: 'Latitude',
            dataIndex: 'latitude',
            key: 'latitude'
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                return toUtcDateString(new Date(val));
            }
        }
    ]

    const cardStyle = {
        textAlign: 'left'
    }

    const onLatChange = (val) =>{
        setLatitude(val);
    }

    const onLongChange = (val) => {
        setLongitude(val);
    }

    const onSubmit = () => {
        insertLocation(longitude, latitude).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            console.log(`an error occurred submitting location`);
        });
    }

    const inputStyle = {
        width: 200
    }

    const colStyle= {
        margin: '5px'
    }
    return <div>
        <Card style={cardStyle} title={`Locations`}>
            <Table dataSource={locations} columns={columns} pagination={false} />
        </Card>
        <Card style={cardStyle} title={'Insert'}>
            <Row>
                <Col style={colStyle}>
                    <InputNumber style={inputStyle} placeholder={`Latitude`} precision={2} onChange={onLatChange} value={latitude}/>
                </Col>
                <Col style={colStyle}>
                    <InputNumber style={inputStyle} placeholder={`Longitude`} precision={2} onChange={onLongChange} value={longitude}/>
                </Col>
                <Col style={colStyle}>
                    <Button onClick={onSubmit}>Submit</Button>
                </Col>
            </Row>
        </Card>
    </div>

}